import React from 'react';
import styled from 'styled-components';

import StatusLabel from 'shared/components/StatusLabel';
import { WorkflowStatus } from 'shared/types/workflow';

import { WorkflowStatusLabelProps } from './types';

const StyledContainer = styled.div``;

// TODO: We need to improve this because the code doesn't look too good.
const renderStatus = (status: WorkflowStatus) => {
  if (!Object.values(WorkflowStatus).includes(status)) {
    return null;
  }

  let backgroundColor;
  let textColor;

  if (status === WorkflowStatus.UP) {
    backgroundColor = 'transparent';
    textColor = '#2f9e5c';
  } else if (status === WorkflowStatus.PENDING || status === WorkflowStatus.DISABLED) {
    backgroundColor='#ebeef5';
    textColor = '#676a70';
  } else if (status === WorkflowStatus.ERROR) {
    backgroundColor = '#d1443f';
    textColor = '#fff';
  } // No `else` statement.

  return (
    <StatusLabel<WorkflowStatus>
      statusLabel={status}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};

// TODO: I'd like to check this because it looks almost the same as the `SourceStatusLabel`
// component but I think it's better to keep them "separated" because they represent
// different concepts.
const WorkflowStatusLabel = ({
  className,
  status,
}: WorkflowStatusLabelProps) => (
  <StyledContainer className={className}>
    {renderStatus(status)}
  </StyledContainer>
);

export default WorkflowStatusLabel;
